export const ACCESS_TOKEN = "ultra-front-desk-access-token";
export const FCM_TOKEN = "ultra-front-desk-fcm-token";
